import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import SubPage from 'uikit/SubPage';

import ReportEmpty from '../../../../Shared/ReportEmpty';
import styles from './AggregatedAnswers.module.scss';

const cx = classNames.bind(styles);

const AggregatedAnswers = ({
  aggregatedStudyAnswers,
  course,
  handleQuestionChange,
  handleClose,
  isVisible,
  nextQuestion,
  previousQuestion,
  question,
  questionInfo,
  aggregateComponent: AggregateQuestion,
  t,
}) => (
  <SubPage
    isOpen={isVisible}
    onExit={handleClose}
    subtitle={course.title}
    title={t('Course/Teacher/Editor/AggregatedAnswers/title')}
  >
    <div className={cx('subpage')}>
      <div className={cx('buttons')}>
        <Button
          icon="chevron-left"
          intent="white"
          isDisabled={!previousQuestion}
          onClick={() => handleQuestionChange(previousQuestion)}
          size="large"
          tooltip={t(
            'Course/Teacher/Editor/AggregatedAnswers/previous-question',
          )}
        />
        <Button
          icon="chevron-right"
          intent="white"
          isDisabled={!nextQuestion}
          onClick={() => handleQuestionChange(nextQuestion)}
          size="large"
          tooltip={t('Course/Teacher/Editor/AggregatedAnswers/next-question')}
        />
      </div>
      {!questionInfo?.isReportable ||
      aggregatedStudyAnswers?.aggregation?.isEmpty ? (
        <ReportEmpty
          isUnsupported={!questionInfo?.isReportable}
          question={question}
          questionInfo={questionInfo}
        />
      ) : (
        aggregatedStudyAnswers?.aggregation?.type === questionInfo?.type && (
          <AggregateQuestion
            aggregation={aggregatedStudyAnswers.aggregation}
            question={question}
            questionInfo={questionInfo}
          />
        )
      )}
    </div>
  </SubPage>
);

AggregatedAnswers.propTypes = {
  aggregatedStudyAnswers: PropTypes.object,
  course: PropTypes.object.isRequired,
  handleQuestionChange: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  nextQuestion: PropTypes.object,
  previousQuestion: PropTypes.object,
  question: PropTypes.object,
  questionInfo: PropTypes.object,
  aggregateComponent: PropTypes.elementType,
  t: PropTypes.func.isRequired,
};

AggregatedAnswers.defaultProps = {
  aggregatedStudyAnswers: undefined,
  nextQuestion: undefined,
  previousQuestion: undefined,
  question: undefined,
  questionInfo: undefined,
  aggregateComponent: undefined,
};

export default AggregatedAnswers;
